export default __webpack_public_path__ + "static/media/contract.59f627ea.mp4";